function setCookie(cname, cvalue, exdays, exmseconds, domain=null) {
    const d = new Date();
    exdays = exdays ? exdays : 0;
    exmseconds = exmseconds ? exmseconds : 0;
    const extime = (exdays*24*60*60*1000) + exmseconds;
    d.setTime(d.getTime() + extime);
    let expires = "expires="+ d.toUTCString();
    const domain_txt = domain ? ";domain=" + domain : "";
    document.cookie =  `${cname}=${cvalue};${expires};path=/${domain_txt}`;
}

function getCookie(name) {
    var cookieArr = document.cookie.split(";");
    for(var i = 0; i < cookieArr.length; i++) { var cookiePair=cookieArr[i].split("=");
    if(name == cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}

function deleteCookie(cname, domain=null) {
    const domain_txt = domain ? ";domain=" + domain : "";
    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${domain_txt}`;
    const d = new Date();
    d.getTime();
}